import Button from './Button';

/** Controlled stepper. The format controller still clamps, locks and saves scores. */
export default function ScoreControl({ label, value, displayValue, disabled, onStep }) {
  return <div className="fc-score-control" role="group" aria-label={`${label} predicted score`}>
    <Button variant="secondary" aria-label={`Increase ${label} score`} disabled={disabled} onClick={() => onStep(1)}>+</Button>
    <output aria-live="polite" aria-label={`${label} score`} className="fc-score-control__value">{displayValue ?? value}</output>
    <Button variant="secondary" aria-label={`Decrease ${label} score`} disabled={disabled} onClick={() => onStep(-1)}>−</Button>
  </div>;
}
